import React from 'react';
import { styled, Divider, DividerProps } from '@mui/material';
import { DesignTokens } from '../specify';

const StyledDivider = styled(Divider)({
    color: DesignTokens.color.grey600,
});

type GivelifyDividerProps = DividerProps & {
    text?: string;
};

export const GivelifyDivider: React.FCC<GivelifyDividerProps> = ({
    text,
    ...props
}) => {
    return <StyledDivider {...props}>{text}</StyledDivider>;
};
